import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";

import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkSpacing } from "uitk-react-spacing";

import { WizardRegionHotwireModel } from "../typings";
import { MobileHeading } from "./MobileHeading";
import { cropResizeSrc } from "src/components/shared/BlossomImage/BlossomImage";
import { useMultiLOBWizardRegion } from "./../WizardRegionContextProvider/MultiLOBWizardRegionContext";

export interface MobileContentWithImageProps {
  model: WizardRegionHotwireModel;
  destinationHero?: React.ReactElement;
  wizard?: React.ReactElement;
}

export const MobileContentWithImage = observer(({ model, destinationHero, wizard }: MobileContentWithImageProps) => {
  const { wizardState } = React.useContext(MobXProviderContext);

  // Override the mobile background image from the model if there is no destination-hero on the page
  if (model.smallBackgroundImage && !destinationHero) {
    wizardState.globalWizardState.config.heroImageSrc = model.smallBackgroundImage;
  }

  // Optimize either the destination-hero image or smallBackgroundImage from model
  const backgroundImageSrc = cropResizeSrc(
    wizardState.globalWizardState.config.heroImageSrc,
    { width: 575, height: 431 },
    "medium"
  );

  const { isMultiLOB } = useMultiLOBWizardRegion();

  return (
    <>
      <UitkFigure ratio={UitkFigureAspectRatioType.R3_2}>
        <UitkImage src={backgroundImageSrc} alt={`${model.title} ${model.innerTitle}`} />
        <UitkScrim type={UitkScrimType.BOTTOM}>
          <UitkSpacing padding={{ blockend: "four" }}>
            <div className="WizardRegionHotwire--Heading">
              <MobileHeading title={model.title} innerTitle={model.innerTitle} />
            </div>
          </UitkSpacing>
        </UitkScrim>
      </UitkFigure>
      <UitkLayoutPosition type="relative" position={{ top: "minus-three" }}>
        <UitkCardAloha>
          {destinationHero && (
            <UitkCardAlohaContentSection className="attribution-text">{destinationHero}</UitkCardAlohaContentSection>
          )}
          {isMultiLOB ? wizard : <UitkCardAlohaContentSection>{wizard}</UitkCardAlohaContentSection>}
        </UitkCardAloha>
      </UitkLayoutPosition>
    </>
  );
});
